// 指令飞行
import React, { useRef, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'
import { App, Layout, theme, Space, Button, Card, Segmented, Form, InputNumber, Divider, Spin, Row, Col, Tag, Tooltip, Alert, Input } from 'antd'
import { SyncOutlined, LoadingOutlined, CloseOutlined, FullscreenExitOutlined, ExpandOutlined, DownloadOutlined, MinusOutlined, CameraOutlined, InfoCircleFilled, ExclamationCircleFilled, CloseCircleFilled, StopOutlined, PlusOutlined, InfoCircleOutlined, BlockOutlined, CaretRightOutlined } from '@ant-design/icons';

import { transformGCJ2WGS, transformWGSGCJ2, demoMap, debounce } from "@/common/js/common.js" //引入公共方法
import dayjs from 'dayjs';
import peg from "@/common/img/peg.png" //标识桩
import { pushFlowLiveAPI, flowLiveUpdateAPI } from '@/server/airportCamera'
import { getWebSocketAddress, getM30AirportNumber, getAirLiveAddress, goToPointByTakeoff, goToPointByFlyTo, returnHome, startVideoAPI, endVideoAPI, takePhotoAPI, changeLensAPI, modifyZoomValueAPI, panTiltControlAPI, getAirportHealthInfoAPI, airportHealthInfoReadAPI, stopFlytoAPI, cancelReturnFlightAPI, getLinePointApi, getKmlLinePointApi } from '@/server/commandFlight.js'
import { getDockElectricityApi } from '@/server/home.js'
import { distance, calculateNewCoordinates } from '@/common/js/common.js'
import LiveVideo from '@/component/LiveVideo/index.js'
import './command_flight.css'

import { GetAltitude } from '@/server/line' //接口 通过经纬度获取海拔（84坐标系）

// import './index.less'

import warning from '@/common/img/video/warning.svg';
import map_jc from "@/common/img/command_flight/map_jc.svg" //机场
import map_dd from "@/common/img/command_flight/map_dd.svg" //到达点位
import map_uavJT from "@/common/img/command_flight/map_uavJT.svg" //无人机箭头
import is_t_Camera from "@/common/img/command_flight/t_Camera.svg" //开始摄像
import is_f_Camera from "@/common/img/command_flight/f_Camera.svg" //停止摄像
import dqszhd from "@/common/img/command_flight/dqszhd.svg" //当前到达航点
import yschdzp from "@/common/img/command_flight/yschdzp.svg" //已经上传的航点照片

import fhgd from "@/common/img/command_flight/head/fhgd.svg" //返航高度
import xy from "@/common/img/command_flight/head/xy.svg" //小雨
import zy from "@/common/img/command_flight/head/zy.svg" //中雨
import dy from "@/common/img/command_flight/head/dy.svg" //大雨
import fs from "@/common/img/command_flight/head/fs.svg" //风速
import wd from "@/common/img/command_flight/head/wd.svg" //温度
import sd from "@/common/img/command_flight/head/sd.svg" //湿度

import Ethernet from "@/common/img/command_flight/head/Ethernet.svg" //以太网
import cell0 from "@/common/img/command_flight/head/cell0.svg" //4G信号 [0,15)
import cell15 from "@/common/img/command_flight/head/cell15.svg" //4G信号 [15,35)
import cell35 from "@/common/img/command_flight/head/cell35.svg" //4G信号 [35,55)
import cell55 from "@/common/img/command_flight/head/cell55.svg" //4G信号 [55,75)
import cell75 from "@/common/img/command_flight/head/cell75.svg" //4G信号 [75,95)
import cell95 from "@/common/img/command_flight/head/cell95.svg" //4G信号 [95,100)

import dl0 from "@/common/img/command_flight/head/dl0.svg" //电量 [0,25)
import dl25 from "@/common/img/command_flight/head/dl25.svg" //电量 [25,50)
import dl50 from "@/common/img/command_flight/head/dl50.svg" //电量 [50,75)
import dl75 from "@/common/img/command_flight/head/dl75.svg" //电量 [75,100)
import dl100 from "@/common/img/command_flight/head/dl100.svg" //电量 100
import dl_charge from "@/common/img/command_flight/head/dl_charge.svg" //充电中

import sdr0 from "@/common/img/command_flight/head/sdr0.svg" //SDR信号  [0,15)   
import sdr15 from "@/common/img/command_flight/head/sdr15.svg" //SDR信号  [15,35)  
import sdr35 from "@/common/img/command_flight/head/sdr35.svg" //SDR信号  [35,55)  
import sdr55 from "@/common/img/command_flight/head/sdr55.svg" //SDR信号  [55,75)  
import sdr75 from "@/common/img/command_flight/head/sdr75.svg" //SDR信号  [75,95)  
import sdr95 from "@/common/img/command_flight/head/sdr95.svg" //SDR信号  [95,100)

import wifi0 from "@/common/img/command_flight/head/wifi0.svg" //WiFi信号  [0,30)
import wifi30 from "@/common/img/command_flight/head/wifi30.svg" //WiFi信号  [30,60)
import wifi60 from "@/common/img/command_flight/head/wifi60.svg" //WiFi信号  [60,90)
import wifi90 from "@/common/img/command_flight/head/wifi90.svg" //WiFi信号  [90,100)
import wifi_close from "@/common/img/command_flight/head/wifi_close.svg" //WiFi信号 关闭
import wifi_none from "@/common/img/command_flight/head/wifi_none.svg" //WiFi信号  没有网络

import t_wrj from "@/common/img/command_flight/head/t_wrj.svg" //已链接上无人机
import f_wrj from "@/common/img/command_flight/head/f_wrj.svg" //未链接上无人机

import t_jc from "@/common/img/command_flight/head/t_jc.svg" //地图上的机场

import uav_t_p from "@/common/img/command_flight/uav/uav_t_p.svg" //已链接上  状态 p
import uav_f_p from "@/common/img/command_flight/uav/uav_f_p.svg" //未链接上  状态 p
import uav_t_a from "@/common/img/command_flight/uav/uav_t_a.svg" //已链接上  状态 a
import uav_f_a from "@/common/img/command_flight/uav/uav_f_a.svg" //未链接上  状态 a
import uav_t_m from "@/common/img/command_flight/uav/uav_t_m.svg" //已链接上  状态 m
import uav_f_m from "@/common/img/command_flight/uav/uav_f_m.svg" //未链接上  状态 m
import uav_ms from "@/common/img/command_flight/uav/uav_ms.svg" // M/S
import uav_t_dl from "@/common/img/command_flight/uav/uav_t_dl.svg" // 无人机满电池电量
import uav_f_dl from "@/common/img/command_flight/uav/uav_f_dl.svg" // 无人机缺电池电量
import uav_xdqfdgd from "@/common/img/command_flight/uav/uav_xdqfdgd.svg" // 相对起飞高度
import uav_xdjcgd from "@/common/img/command_flight/uav/uav_xdjcgd.svg" // 距离机场距离

import uav_t_ssbz from "@/common/img/command_flight/uav/uav_t_ssbz.svg" //已链接上  上视规避
import uav_f_ssbz from "@/common/img/command_flight/uav/uav_f_ssbz.svg" //未链接上  上视规避

import uav_t_xsbz from "@/common/img/command_flight/uav/uav_t_xsbz.svg" //已链接上  下视规避
import uav_f_xsbz from "@/common/img/command_flight/uav/uav_f_xsbz.svg" //未链接上  下视规避

import uav_t_spbz from "@/common/img/command_flight/uav/uav_t_spbz.svg" //已链接上  水平规避
import uav_f_spbz from "@/common/img/command_flight/uav/uav_f_spbz.svg" //未链接上  水平规避

import convergence0 from "@/common/img/command_flight/uav/convergence0.svg" //收敛 未开始
import convergence1 from "@/common/img/command_flight/uav/convergence1.svg" //收敛 收敛中
import convergence2 from "@/common/img/command_flight/uav/convergence2.svg" //收敛 收敛成功
import convergence3 from "@/common/img/command_flight/uav/convergence3.svg" //收敛 收敛失败

import rtk from "@/common/img/command_flight/uav/uav_info/rtk.svg" // rtk数量
import gps from "@/common/img/command_flight/uav/uav_info/gps.svg" // gps数量
import dj from "@/common/img/command_flight/uav/uav_info/dj.svg" // 东经
import bw from "@/common/img/command_flight/uav/uav_info/bw.svg" // 北纬
import xdqfgd from "@/common/img/command_flight/uav/uav_info/xdgd.svg" // 相对起飞高度
import hbgd from "@/common/img/command_flight/uav/uav_info/hbgd.svg" // 海拔高度 
import spsd from "@/common/img/command_flight/uav/uav_info/spsd.svg" // 水平速度
import czsd from "@/common/img/command_flight/uav/uav_info/czsd.svg" // 垂直速度
import jcjl from "@/common/img/command_flight/uav/uav_info/jcjl.svg" // 距离机场距离

import Marquee from 'react-fast-marquee';
// import './newGodMap.css'
const { Content } = Layout;

function VideoPatrolMonitor (props) {
  let dockId = props.dockId;//当前选择的机场
  const dockIdRef = useRef(props.dockId);//当前机场
  let videoTypes = props.videoTypes.map((item) => { return item.value });//视频类型

  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数

  const {
    token: { colorBorderSecondary, colorText },
  } = theme.useToken(); //获取主题颜色
  const { message, modal } = App.useApp();
  const { confirm } = modal;

  const mapRef = useRef();
  const closeWs = useRef(true)//是否可以重启ws
  // const interval = useRef()//计时器
  const liveInterval = useRef();//直播计时器
  const isShowFly = useRef(false)//是否可看
  const [isShowFlyState, setIsShowFlyState] = useState(false)//是否可看监听状态

  const ws = useRef(null);
  const token = localStorage.getItem('dock_token');
  const [loading, setLoading] = useState(props.loading)//加载中···
  const [opacity, setOpacity] = useState(true);//切换图层

  const [camera, setCamera] = useState(false)//开始摄像

  const [cameraDate, setCameraDate] = useState(null)//摄影时长
  const [zoom, setZoom] = useState(10); //地图缩放比例

  const [lensType, setLensType] = useState('wide')// wide:广角 || zoom:变焦  || ir:红外
  const [zoomValue, setZoomValue] = useState(5)//变焦数值 （2-10）
  const [pitchAngle, setPitchAngle] = useState('lookingUp')//俯仰角  //topView:俯视 || lookingUp :仰视
  const downMouse = useRef(false)//是否按下鼠标
  const [downMouseState, setDownMouseState] = useState(false)
  const [videoWidth, setVideoWidth] = useState(300)//直播位置的  宽
  const [videoHeight, setVideoHeight] = useState(225)//直播位置的  高
  const mouseWidth = useRef(0)

  const [divLeft, setDivLeft] = useState(0);//监听鼠标指针
  const [divTop, setDivTop] = useState(0);//监听鼠标指针
  const [floating, setFloating] = useState({//鼠标指向显示信息
    visible: false,//是否可见
    title: '',//航线名称
  });

  const [curRadius, setCurRadius] = useState(7000)//当前所需圆半径
  const [curOutherPoint, setCurOutherPoint] = useState([])//当前圆的另一个点
  const [curPixelsRadius, setCurPixelsRadius] = useState(0)//当前像素半径

  const [warningMessage, setWarningMessage] = useState({
    isOpen: false,//打开消息集
    isRead: false,//是否已读
    mainMsg: {},//最主要的消息集
    UAVMsg: [],//无人机消息集
    airportMsg: [],//机场消息集
    ids: [],//所有信息的id集合
  })

  const msgInterval = useRef()

  const [lineList, setLineList] = useState([])//获取到的航线列表信息

  // ------------------------------------------定点飞行 ↓
  const [anchorPointForm] = Form.useForm();

  const [takeoffLoading, setTakeoffLoading] = useState(false)

  const [anchorPoint, setAnchorPoint] = useState([])//选定的定点位置
  const [anchorPointList, setAnchorPointList] = useState([])//指令飞行飞出去后的所有点位

  const [coordinatePointInfo, setCoordinatePointInfo] = useState({//表单
    lng: '',//经度
    lat: '',//纬度
    cruiseSpeed: 15,//巡航速度
    takeoffAltitude: 80,//起飞高度
    takeoffElevation: 0,//takeoff机场海拔
    surfaceElevation: 0,//地表海拔
    reachingAltitude: 0,//到达高度
    returnAltitude: 0,//返航海拔
    lastFlightAltitude: 0,//上次飞行时候的高度
  })// 坐标点的经纬度信息

  const isEditMap = useRef(false)//是否能 编辑航线
  const isClickBtn = useRef(false)//是否 添加定点线路
  const isReturnFlight = useRef(false)//是否 返航

  const isCompute = useRef(false)//是否 计算海拔中


  // 当前无人机的档位
  // 1： (P)停止
  // 2： (A)指定航线-自动飞行
  // 3： (M)未指定航线-手动飞行
  const droneStatus = useRef(2)


  //当前指令飞行状态
  //  1: 设置  takeoff 位置
  //  2: takeoff 飞行中
  //  3: takeoff 到达指定位置
  //  4: 设置  flyto 位置
  //  5: flyto 飞行中
  //  6: 停止飞行
  //  7: 返航中
  const implementType = useRef(0)
  const [implementTypeState, setImplementTypeState] = useState(0)//用于监听
  // ------------------------------------------定点飞行 ↑


  //  -------------------------------------------------- 直播相关 ↓
  const [loadingAll, setLoadingAll] = useState(true);//全局loading
  const updataInterval = useRef()// updata  计时器
  const [videoId, setVideoId] = useState('')//直播id
  const liveUrl = useRef('')
  const isLivePlay = useRef(false)//是否处于直播中
  const [liveUrlState, setLiveUrlState] = useState('')//直播地址
  const [UAVLiveStreamStart, setUAVLiveStreamStart] = useState(false)//无人机直播是否启动（按照无人机状态来定）

  //  -------------------------------------------------- 直播相关 ↑


  const [globalStatus, setGlobalStatus] = useState({//全局状态
    isLiveShow: false,//是否展示直播页面
    isPipeline: false,//当前是否存在一条管线
    isOpenSeeUAVInfo: false,//是否查看无人机的参数信息
    isOpenSeeAirportInfo: false,//是否查看机场的参数信息
    title: '',
  })

  const [mapParameters, setMapParameters] = useState({//地图基础参数
    mapZoomScale: 17,//地图缩放比例
    mapScale: 3875.8509003722434,//地图比例尺
    mapDefaultScale: 3875.8509003722434,//默认比例尺
    mapCenterPoint: [0, 0],//地图中心点
    liveAddressArr: [],//直播地址
    liveAddressBtn: {
      type: 'cam',
      address: 0,
    },//直播地址按钮
  })

  const [pipelineAndPoint, setPipelineAndPoint] = useState({//管线及航点坐标
    pipeline: [],//管线坐标
    waypointCoordinates: [],//航点坐标
  })

  const [airportCoordinate, setAirportCoordinate] = useState([0, 0])//机场坐标
  const [uavCoordinate, setUAVCoordinate] = useState([0, 0])//无人机坐标
  const [airportData, setAirportData] = useState({})//ws中  机场
  const [UAVData, setUAVData] = useState({})//ws中  无人机

  // 飞行器当前状态
  const status = ["待机", "起飞准备", "起飞准备完毕", "手动飞行", "自动起飞", "航线飞行", "全景拍照", "智能跟随", "ADS-B躲避", "自动返航", "自动降落", "强制降落", "三桨叶降落", "升级中", "未连接", "APAS", "虚拟摇杆状态", "指令飞行"]
  const dronestatus = ["无意义", "电池电量不足（返航、降落）", "电池电压不足（返航、降落）", "电压严重过低（返航、降落）", "遥控器按键请求（起飞、返航、降落）", "App 请求（起飞、返航、降落）", "遥控信号丢失（返航、降落、悬停）", "导航、SDK 等外部设备触发（起飞、返航、降落）", "进入机场限飞区（降落）", "虽然触发了返航但是因为距离 Home 点距离太近（降落）", "虽然触发了返航但是因为距离 Home 点距离太远（降落）", "执行航点任务时请求（起飞）", "返航阶段到达 Home 点上方后请求（降落）", "飞行器高度下降，距地面 0.7m（二段降落限低）时，继续下降导致（降落）", "App、SDK 等设备强制突破限低保护进行（降落）", "因为周围有航班经过而请求（返航、降落）", "因为高度控制失败请求（返航、降落）", "智能低电量返航后进入（降落）", "AP 控制飞行模式（手动飞行）", "硬件异常（返航、降落）", "防触地保护结束（降落）", "返航取消 (悬停)", "返航时遇到障碍物（降落）", "机场场景下大风触发（返航）"];// 无人机错误原因


  const getAirportNumberByToken = async () => {// 进入页面即刻获取状态信息  用以确定是否展示前端页面
    if (ws.current) {
      ws.current.close()
      ws.current = null
    }
    closeWs.current = true
    setLoading(true)
    getRoutesPoint()
    let glo = globalStatus
    let pip = pipelineAndPoint
    let obj = {
      access_token: token,
      CompanyID: localStorage.getItem('dock_CompanyID'),
      dock_id: dockIdRef.current ? dockIdRef.current : ''
    }
    let res = await getM30AirportNumber(obj);
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错啦，请稍后重试！');
      glo.title = res.msg
      setGlobalStatus({ ...glo })
      setTimeout(() => {
        setLoading(false)
      }, 1000);
      return
    }
    let coo = coordinatePointInfo
    coo.takeoffElevation = res.data.dock_info.dockAlt
    coo.lastFlightAltitude = res.data.dock_info.dockAlt
    setCoordinatePointInfo({ ...coo })
    setCurRadius(res.data.dock_info.radius)
    let map = mapParameters
    map.mapCenterPoint = [Number(res.data.dock_info.longitude) || 0, Number(res.data.dock_info.latitude) || 0]
    setMapParameters({ ...map })
    getWebSocket(res.data.dock_info.aircraftSn, res.data.dock_info.dockSn)
    // 管线   转84
    let RoutesPoints = []
    res.data.Routes_Points?.forEach((res) => {
      let arr = [Number(parseFloat(transformGCJ2WGS({ lat: res.latitude, lon: res.longitude }).lon).toFixed(7)), Number(parseFloat(transformGCJ2WGS({ lat: res.latitude, lon: res.longitude }).lat).toFixed(7))];
      // let arr = [res.longitude, res.latitude]
      RoutesPoints.push(arr)
    })
    // 航点   转84
    let InsPoints = []
    res.data.Ins_Points?.forEach((res) => {
      let arr = [Number(parseFloat(transformGCJ2WGS({ lat: res.latitude, lon: res.longitude }).lon).toFixed(7)), Number(parseFloat(transformGCJ2WGS({ lat: res.latitude, lon: res.longitude }).lat).toFixed(7))];
      // let arr = [res.longitude, res.latitude]
      InsPoints.push(arr)
    })
    pip.pipeline = RoutesPoints
    pip.waypointCoordinates = InsPoints
    setPipelineAndPoint({ ...pip })
    glo.isPipeline = true
    setGlobalStatus({ ...glo })
    liveAddress()

    if (JSON.parse(localStorage.getItem('dock_DefaultMapPoints'))) {
      showMap(JSON.parse(localStorage.getItem('dock_DefaultMapPoints')))
    } else {
      showMap(res.data.dock_info.latitude ? [Number(res.data.dock_info.latitude), Number(res.data.dock_info.longitude)] : undefined)
    }
  }

  const getAirporintInfo = async () => { //获取机场健康状态
    let war = warningMessage
    let res = await getAirportHealthInfoAPI({ access_token: token, dock_id: dockIdRef.current })
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错啦，请稍后重试！');
      return
    }
    let ids = []
    war.UAVMsg = res.data?.aircraftHms || []
    war.airportMsg = res.data?.dockHms || []
    war.mainMsg = res.data.mainmsg || {}

    // war.isRead = res.data?.aircraftHms.length > 0 || res.data?.dockHms.length > 0
    res.data?.aircraftHms.forEach((res) => {
      ids.push(res.id)
    })
    res.data?.dockHms.forEach((res) => {
      ids.push(res.id)
    })
    war.ids = ids
    setWarningMessage({ ...war })
  }

  const liveAddress = async () => {//获取直播地址
    liveUrl.current = ''
    setLiveUrlState('')
    setLoadingAll(true)
    let obj = {
      access_token: token,
      camera: 'cam',
      dock_id: dockIdRef.current ? dockIdRef.current : '',//当前机场id
    }
    let res = await getAirLiveAddress(obj);
    if (res.ret !== 200) {
      setLoadingAll(false)
      return
    }
    setTimeout(() => {
      setLoadingAll(false)
      liveUrl.current = res.data?.url?.default || ''
      setLiveUrlState(res.data?.url?.default || '')
      setVideoId(res.data.video_id)
    }, 2000);
  }

  const getRoutesPoint = async () => {//获取航线信息
    let res = await getLinePointApi({ access_token: token, type: '1,7,10' })
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }

    let arr = []
    if (res.data.length > 0) {
      res.data.forEach((res, index) => {
        let obj = {
          ...res,
          id: res.r_id || res.id,//r_id 为 标识桩   id为 管线
          fileType: 1,//文件类型   1：excel   2:kml
          points: editPipePoint(res.point_lines, 1),
        }
        arr.push(obj)
      })
    }
    getKmlRoutesPoint(arr)
  }

  const getKmlRoutesPoint = async (list) => {//获取KML文件的航线信息
    let res = await getKmlLinePointApi({ access_token: token })
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
    if (res.data.length > 0) {
      res.data.forEach((res, index) => {
        let obj = {
          ...res,
          fileType: 2,//文件类型   1：excel   2:kml
          points: editPipePoint(res.point_lines, 2),
        }
        list.push(obj)
      })
    }
    list.sort((a, b) => { return b.id - a.id })//将数据通过id进行倒叙
    setLineList([...list])
  }

  const editPipePoint = (data, fileType) => { //编辑 管线数据及标识桩数据
    if (data && data.length > 0) {
      if (fileType === 1) {
        return data.map((res, index) => {
          return [Number(res.lat_wgs84), Number(res.lon_wgs84)]
        })
      }
      if (fileType === 2) {
        let mainArr = []
        data.forEach((res) => {
          let arr = []
          res.forEach((ele, idx) => {
            arr.push([Number(ele.lat_wgs84), Number(ele.lon_wgs84)])
          })
          mainArr.push(arr)
        })
        return mainArr
      }
      return []
    } else {
      return []
    }
  }

  const objectsBecomeList = (data, list, name = null) => {//将多级objcet转换成单级objcet
    Object.keys(data).forEach(res => {
      if (typeof data[res] === 'object') {
        objectsBecomeList(data[res], list, res)
      } else {
        if (name) {
          let na = `${name}_${res}`
          list[na] = data[res]
        } else {
          list[res] = data[res]
        }
      }
    })
  }

  const getWebSocket = async (aircraftSn, dockSn) => { // 获取 webSocket  地址
    let obj = {}
    let UAVobj = {}
    let airTime = 1
    let uavTime = 1
    let airNum = airportCoordinate[0] === 0 ? 1 : 2
    let uavNum = uavCoordinate[0] === 0 ? 1 : 2
    let res = await getWebSocketAddress({ access_token: token, type: '1' })
    if (res.ret === 200) {
      ws.current = new WebSocket(res.data);

      ws.current.onopen = (msg) => {//链接开启
      };

      ws.current.onmessage = e => {// 成功获取数据
        try {
          let data = JSON.parse(e.data)

          // console.log('ws的数据', data.data);
          if (data.biz_code === 'dock_osd' && data.data.sn === dockSn) {//机场
            // console.log('机场数据：', data.data);
            airTime = dayjs().valueOf()
            objectsBecomeList(data.data.host, obj)
            setAirportData({ ...obj, sn: data.data.sn })
            if (airNum === 1 && obj.longitude) {
              setAirportCoordinate([Number(obj.longitude) || 0, Number(obj.latitude) || 0])
              airNum += 1
            }
            if (implementType.current === 0 && obj.longitude) {
              let coo = { ...coordinatePointInfo }
              let point = [Number(obj?.longitude || 0), Number(obj?.latitude || 0)]
              implementType.current = 1
              setImplementTypeState(1)
              isClickBtn.current = true
              localStorage.setItem('dock_anchorPoint', [point[0], point[1]]);
              coo.lng = point[0]
              coo.lat = point[1]
              coo.surfaceElevation = coo.takeoffElevation
              coo.reachingAltitude = Number(coo.surfaceElevation) + Number(coo.takeoffAltitude)
              // 创建定位点后将默认值写入表单
              anchorPointForm.setFieldsValue({
                lng: point[0],//经度
                lat: point[1],//纬度
                cruiseSpeed: coo.cruiseSpeed,//巡航速度
                takeoffAltitude: coo.takeoffAltitude,//起飞高度
                surfaceElevation: coo.surfaceElevation,//地表海拔
                reachingAltitude: coo.reachingAltitude,//到达高度
              })
              setAnchorPoint([...point])
              setCoordinatePointInfo({ ...coo })
            }
          }

          if (data.biz_code === 'device_osd' && data.data.sn === aircraftSn) {//无人机

            setLoading(false)
            isShowFly.current = true
            setIsShowFlyState(true)

            uavTime = dayjs().valueOf()
            objectsBecomeList(data.data.host, UAVobj)
            setUAVData({ ...UAVobj, sn: data.data.sn })

            if (uavNum === 1 && UAVobj.longitude) {
              setAirportCoordinate([Number(UAVobj.longitude) || 0, Number(UAVobj.latitude) || 0])
              uavNum += 1
            }
          }

          if (data.biz_code === 'fly_to_point_progress') { }

        } catch (error) {
          // message.warning('当前机场状态错误，请确认机场是否正确链接')
        }
      }

      ws.current.onerror = (msg) => {//报错信息
        closeWs.current = false
        isShowFly.current = false
        setIsShowFlyState(false)
      }

      ws.current.onclose = (msg) => {//链接断开
        isShowFly.current = false
        setIsShowFlyState(false)
        airNum = 1
        setAirportData({})
        setUAVData({})
        clearInterval(settime)
      };
      // 6秒一次检查当前ws传回来的数据是否还在
      let settime = setInterval(() => {
        let airTimes = Math.abs(Math.floor(dayjs().valueOf() - airTime) / 1000)
        let uavTimes = Math.abs(Math.floor(dayjs().valueOf() - uavTime) / 1000)
        if (airTimes > 6) {
          setAirportData({})
          if (closeWs.current && ws.current) {
            ws.current.close()
            ws.current = null
            getAirportNumberByToken()
          }
        }
        if (uavTimes > 6) {
          setUAVData({})
          isShowFly.current = false
          setIsShowFlyState(false)
          implementType.current = 1
          setImplementTypeState(1)
        }
      }, 5000);
    } else {
      message.warning(res.msg || '系统出错啦，请稍后重试！')
    }
  }

  const GetAltitudeFun = async (arr) => {//根据经纬度获取海拔
    isCompute.current = true
    let params = {
      access_token: token,
      longitude: arr[0],
      latitude: arr[1],
    }
    let res = await GetAltitude(params);
    isCompute.current = false
    if (res.ret !== 200 || !res.data) {
      message.warning('海拔获取失败，请联系管理员或者重试');
      return 0
    } else {
      return Number(res.data[0]?.elevation)
    }

  }

  const onFinish = async (values) => {// 指令飞行 表单提交
    setTakeoffLoading(true)
    if (implementType.current === 1) {//执行takeoff
      if (!Number(values.lat)) { message.warning('维度不对！'); return }
      if (!Number(values.lng)) { message.warning('经度不对！'); return }
      let obj = {
        access_token: token,
        dock_id: dockIdRef.current ? dockIdRef.current : '',//机场id
        target_latitude: values.lat,//起飞到达纬度
        target_longitude: values.lng,//起飞到达经度
        max_speed: values.cruiseSpeed,//飞行速度
        rth_altitude: values.takeoffAltitude,//起飞返航高度=>起飞高度（高度）
        target_height: values.reachingAltitude,//起飞到达海拔=>到达高度(高度+海拔)
      }
      let res = await goToPointByTakeoff(obj)
      if (res.ret !== 200) {
        message.warning(res.msg || '数据跑丢了')
        setTakeoffLoading(false)
        return
      }
      message.success(res.msg || '执行takeoff成功')
    }

    if (implementType.current === 4) { //执行flyto
      let obj = {
        access_token: token,
        dock_id: dockIdRef.current ? dockIdRef.current : '',//机场id
        latitude: values.lat,//起飞到达纬度
        longitude: values.lng,//起飞到达经度
        max_speed: values.cruiseSpeed,//飞行速度
        height: values.reachingAltitude,//高度->飞行海拔(高度+海拔)
      }
      let res = await goToPointByFlyTo(obj)
      if (res.ret !== 200) {
        message.warning(res.msg || '数据跑丢了')
        setTakeoffLoading(false)
        return
      }
      message.success(res.msg || '执行flyto成功')
    }
  }

  const returnBack = async () => { //返航
    isEditMap.current = false
    let res = await returnHome({ access_token: token, dock_id: dockIdRef.current, })
    if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }

    setAnchorPoint([])
    message.success(res.msg || '返航成功')

    let point = [Number(airportData?.longitude || 0), Number(airportData?.latitude || 0)]
    anchorPointForm.setFieldsValue({
      lng: point[0] || 0,//经度
      lat: point[1] || 0,//纬度
    })

    let coo = coordinatePointInfo
    coo.lng = point[0] || 0
    coo.lat = point[1] || 0
    setCoordinatePointInfo({ ...coo })
  }

  const numDate = (totalSeconds) => {//计算时分秒
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (num) => num.toString().padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
  }

  const returnData = (data) => {// 直播组件回调
    if (data.canPushFlow) {
      // let aaa = 'https://media.w3.org/2010/05/sintel/trailer.mp4'
      pushFlow()
    }
    isLivePlay.current = data.isLivePlay
    if (!data.isLeave && data.isLivePlay) {
      clearInterval(updataInterval.current)
      updataInterval.current = null
      updataInterval.current = setInterval(() => {
        updataLive()
      }, 30000);
    } else {
      clearInterval(updataInterval.current)
      updataInterval.current = null
    }

    if (data.isRefresh) { liveAddress() }//点击刷新，重新请求
  }

  const updataLive = async () => {//更新直播
    // console.log(`更新${videoId}`, dayjs().valueOf());
    let res = await flowLiveUpdateAPI({
      access_token: token,
      video_id: videoId
    })
    if (res.ret !== 200) { message.warning(res.msg || '更新失败'); return }
  }

  const pushFlow = async () => {// 直播推流
    setLoadingAll(true)
    let obj = {
      access_token: token,
      camera: 'cam',
      videoQuality: 0,
      dock_id: dockIdRef.current,//当前机场id
    }
    let res = await pushFlowLiveAPI(obj)
    if (res.ret !== 200) { message.warning(res.msg || '推流失败'); setLoadingAll(false); return }
    setTimeout(() => {
      setLoadingAll(false);
      liveUrl.current = res.data?.url
      setLiveUrlState(res.data?.url)
      // setLiveUrlState('https://media.w3.org/2010/05/sintel/trailer.mp4')
      setVideoId(res.data.video_id)
    }, 2000);
  }

  //鼠标移动事件
  document.onmousemove = function () {
    setDivTop(window.event.pageY);
    setDivLeft(window.event.pageX);
  }

  useEffect(() => {
    if (!warningMessage.isRead) {
      msgInterval.current = setInterval(() => {
        getAirporintInfo()
      }, 10000);
    } else {
      clearInterval(msgInterval.current)
      msgInterval.current = null
    }

    return () => {
      // 获取消息集
      clearInterval(msgInterval.current)
      msgInterval.current = null
    }
    // eslint-disable-next-line
  }, [warningMessage.isRead])

  useEffect(() => {//摄像
    let num = 0
    if (camera) {
      const timer = setInterval(() => {
        num += 1
        setCameraDate(numDate(num))
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [camera])

  useEffect(() => {
    switch (implementType.current) {
      case 1: //设置  takeoff
        isEditMap.current = true//是否可编辑
        break;
      case 2: //takeoff 飞行中
        isEditMap.current = false
        setTakeoffLoading(false)
        break;
      case 3: //takeoff 到达指定位置
        break;
      case 4: //设置  flyto
        isEditMap.current = true
        isClickBtn.current = false
        setTakeoffLoading(false)
        break;
      case 5: //flyto 飞行中
        isEditMap.current = false
        break;
      case 6: //flyto 到达指定位置
        break;
      case 7: //flyto 到达指定位置
        break;
      default:
        break;
    }
    // eslint-disable-next-line
  }, [implementTypeState])

  useEffect(() => {
    if (videoTypes.length > 0) {
      let list = [
        { value: 'dock', label: '机场', idx: 1 },
        { value: 'fpv', label: 'FPV', idx: 2 },
        { value: 'cam', label: '镜头', idx: 3 },
      ];
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        if (videoTypes.indexOf(list[i].idx) >= 0) {
          arr.push(list[i]);
        }
      }
    }
    return () => {
      if (ws.current) {//如果websoket存在  在切换页面时将其关闭
        closeWs.current = false
        ws.current.close()
        ws.current = null
      }
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {// 监听机场id
    if (props.dockId) {
      getAirporintInfo()
      getAirportNumberByToken();
    }
    // eslint-disable-next-line
  }, [props.dockId])

  const [log, setLog] = useState([])
  useEffect(() => {  // 无人机状态 监听
    let aaa = log
    aaa.push(`${UAVData.mode_code}_${status[UAVData.mode_code]}`)
    setLog([...aaa])

    if ((UAVData?.mode_code || UAVData?.mode_code === 0) && UAVData?.mode_code !== 14) { setUAVLiveStreamStart(true) } else { setUAVLiveStreamStart(false) }//是否启用无人机直播画面



    if (UAVData.mode_code === 0) {//待机
      let coo = { ...coordinatePointInfo }
      let point = [Number(airportData?.longitude || 0), Number(airportData?.latitude || 0)]
      implementType.current = 1
      setImplementTypeState(1)
      isClickBtn.current = true
      isEditMap.current = true
      coo.lng = point[0]
      coo.lat = point[1]
      coo.surfaceElevation = coo.takeoffElevation
      coo.reachingAltitude = Number(coo.surfaceElevation) + Number(coo.takeoffAltitude)
      // 创建定位点后将默认值写入表单
      anchorPointForm.setFieldsValue({
        lng: point[0],//经度
        lat: point[1],//纬度
        cruiseSpeed: coo.cruiseSpeed,//巡航速度
        takeoffAltitude: coo.takeoffAltitude,//起飞高度
        surfaceElevation: coo.surfaceElevation,//地表海拔
        reachingAltitude: coo.reachingAltitude,//到达高度
      })
      setAnchorPoint([...point])
      setCoordinatePointInfo({ ...coo })
    } else if (UAVData.mode_code === 1) {//起飞准备 
    } else if (UAVData.mode_code === 3) {//手动飞行
      implementType.current = 4
      setImplementTypeState(4)
    } else if (UAVData.mode_code === 9) {//自动返航
      implementType.current = 7
      setImplementTypeState(7)
      setAnchorPoint([Number(airportData?.longitude || 0), Number(airportData?.latitude || 0)])
      setAnchorPointList([])
    } else if (UAVData.mode_code === 17) {//飞行中
      if (implementType.current === 1) {
        implementType.current = 2
        setImplementTypeState(2)
      }
      if (implementType.current === 4) {
        implementType.current = 5
        setImplementTypeState(5)
      }
    } else if (!airportData.drone_in_dock && JSON.stringify(UAVData) !== '{}') {//不在其他状态   且   无人机不在机场内
      implementType.current = 4
      setImplementTypeState(4)
    }

    return () => {
      setUAVLiveStreamStart(false)
    }

    // eslint-disable-next-line
  }, [UAVData.mode_code])

  const MouseMove = (event) => {  // 监听鼠标移动
    let wid = videoWidth + (event.clientX - mouseWidth.current) * 1.01
    let hei = (wid * 3) / 4
    let pmH = window.innerHeight - 344
    if (hei > pmH) {
      hei = pmH
      wid = (hei * 4) / 3
    }
    if (hei < 225) {
      hei = 225
      wid = (hei * 4) / 3
    }

    setVideoWidth(wid)
    setVideoHeight(hei)
  }

  //获取机场电量
  const getDockElectricity = async () => {
    let params = {
      access_token: token,
      dock_id: dockIdRef.current
    }
    let res = await getDockElectricityApi(params);
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      return;
    }

    if (!res.data.ws_host || !res.data.dockSn) {
      message.warning('暂未获取到ws地址或机场编号');
      setLoading(false)
      return;
    }

    let info = res.data;

    setTimeout(() => {
      setLoading(false)
      confirm({
        title: '电量提醒',
        icon: <ExclamationCircleFilled />,
        content: '当前无人机电量为' + res.data.battery_percent + '%，是否起飞',
        onOk () {
          isEditMap.current = false
          document.getElementById("anchorPointForm").click()
          let anc = anchorPointList
          anc.push([Number(airportData?.longitude || 0), Number(airportData?.latitude || 0)])
          anc.push(anchorPoint)
          setAnchorPointList([...anc]);
        },
        onCancel () {
          if (ws.current) {
            ws.current.close()
            ws.current = null
          }
        }
      });
    }, 1500);

  }

  useEffect(() => {  // 监听 鼠标移动
    if (downMouse.current) {
      window.addEventListener('mousemove', MouseMove)
    }
    return () => {
      window.removeEventListener('mousemove', MouseMove)
    }
    // eslint-disable-next-line
  }, [downMouseState])




  // -----------------------------------------本地化-------------------------------------------------------------

  const showMap = (centerPoint) => {//展示地图
    // BM.Config.HTTP_URL = 'http://www.bigemap.com:9000';
    // mapRef.current = BM.map('map', 'bigemap.zhongkexingtu', { center: centerPoint, zoom: 17, zoomControl: false, attributionControl: false, });

    mapRef.current = demoMap(centerPoint)

    mapRef.current.on('click', async (e) => {
      if (isEditMap.current && implementType.current !== 0 && implementType.current !== 1) {

        let value = { lng: Number(e.latlng.lng.toFixed(6)), lat: Number(e.latlng.lat.toFixed(6)), }

        let coo = { ...coordinatePointInfo }
        setAnchorPoint([value.lng, value.lat])//当前点击的位置
        localStorage.setItem('dock_anchorPoint', [value.lng, value.lat]);
        coo.lng = value.lng
        coo.lat = value.lat
        coo.surfaceElevation = [1, 2].indexOf(implementType.current) > -1 ? coo.takeoffElevation : await GetAltitudeFun([value.lng, value.lat])
        coo.reachingAltitude = Number(coo.surfaceElevation) + Number(coo.takeoffAltitude)
        // 创建定位点后将默认值写入表单
        anchorPointForm.setFieldsValue({
          lng: value.lng,//经度
          lat: value.lat,//纬度
          cruiseSpeed: coo.cruiseSpeed,//巡航速度
          takeoffAltitude: coo.takeoffAltitude,//起飞高度
          surfaceElevation: coo.surfaceElevation,//地表海拔
          reachingAltitude: coo.reachingAltitude,//到达高度
        })
        setCoordinatePointInfo({ ...coo })
        isClickBtn.current = true
      }
    })
  }

  useEffect(() => { //监听机场 获取数据
    // 机场位置
    if (airportData?.longitude && airportData?.longitude > 0) {
      let dockIcon = BM.icon({
        iconUrl: map_jc,
        iconSize: [18, 18],
        iconAnchor: [9, 9],//[左右，上下]
        popupAnchor: [0, 0],
        shadowUrl: 'my-icon-shadow.png',
        shadowSize: [0, 0],
        shadowAnchor: [0, 0],
      });
      BM.marker([Number(airportData?.latitude || 0), Number(airportData?.longitude || 0)], { draggable: false, icon: dockIcon, title: '机场', }).addTo(mapRef.current)
    }
  }, [airportData])


  const marker_UAVPointRef = useRef()//无人机箭头 实例
  useEffect(() => {
    if (marker_UAVPointRef.current) {
      marker_UAVPointRef.current.remove()
      marker_UAVPointRef.current = null
    }
    if (UAVData.longitude) {
      let UAVIcon = BM.icon({
        iconUrl: map_uavJT,
        iconSize: [24, 24],
        iconAnchor: [12, 12],//[左右，上下]
        popupAnchor: [0, 0],
        shadowUrl: 'my-icon-shadow.png',
        shadowSize: [0, 0],
        shadowAnchor: [0, 0],
      });
      marker_UAVPointRef.current = BM.marker([UAVData.latitude, UAVData.longitude], { draggable: false, icon: UAVIcon, title: '无人机', rotationAngle: UAVData?.attitude_head, })
        .setZIndexOffset(950)
        .addTo(mapRef.current)
    } else { setAnchorPointList([]) }

    // eslint-disable-next-line
  }, [UAVData.latitude])

  useEffect(() => {//所有管线 及其 标识桩
    if (lineList.length > 0) {
      lineList.forEach((res, index) => {
        if (res.pipe_type === 1) {//管线
          BM.polyline(res.points, { color: '#FFBD0A', }).addTo(mapRef.current)
        }

        if (res.pipe_type === 3 && res.point_lines.length > 0) {//标识桩
          res.point_lines.forEach(ele => {
            let stakeIcon = BM.divIcon({
              className: '',
              iconAnchor: [0, 0],//[左右，上下]
              zIndexOffset: -1000,
              html: `
                <div>
                <img class="shadow pos_abs " src="${peg}" alt="标识桩" style="top: -93px; left: -14px;"/>
                <div class="pegpoint pos_abs  h17 w78 flex jcc align_center" style="top: -58px; left: -38px; color: rgb(0, 0, 0);">${ele.pt_name}</div></div>
                `
            });
            BM.marker([ele.lat_wgs84, ele.lon_wgs84], { draggable: false, icon: stakeIcon, title: res.pt_name, zIndex: 1 }).addTo(mapRef.current)
          })
        }
      })
    }
  }, [lineList])

  const marker_anchorPoint = useRef(null)//当前点击的位置
  useEffect(() => {

    if (marker_anchorPoint.current) {
      marker_anchorPoint.current.remove()
      marker_anchorPoint.current = null
    }
    if (anchorPoint.length > 0) {

      let pointIcon = BM.icon({
        iconUrl: map_dd,
        iconSize: [36, 36],
        iconAnchor: [18, 30],//[左右，上下]
        popupAnchor: [0, 0],
        shadowUrl: 'my-icon-shadow.png',
        shadowSize: [0, 0],
        shadowAnchor: [0, 0],
      });

      marker_anchorPoint.current =
        BM.marker([anchorPoint[1], anchorPoint[0]],
          { draggable: false, icon: pointIcon, title: '机场', })
          .setZIndexOffset(920)
          .addTo(mapRef.current)
    }



  }, [anchorPoint])

  const polyline_anchorPointListRef = useRef(null)//当前点击位置的集合  
  useEffect(() => {
    console.log('anchorPointList', anchorPointList)
    if (polyline_anchorPointListRef.current) {
      polyline_anchorPointListRef.current.remove()
      polyline_anchorPointListRef.current = null
    }

    if (anchorPointList.length > 0 && UAVData.longitude) {
      polyline_anchorPointListRef.current = BM.polyline(anchorPointList.map(res => { return [res[1], res[0]] }), { color: '#00B5FF', }).addTo(mapRef.current)
    }

    // eslint-disable-next-line
  }, [anchorPointList])

  // -----------------------------------------本地化-------------------------------------------------------------

  return (
    <>
      <>{/* 主体 */}
        <div className='pos_rel hei100'>

          {/* 地图 */}
          <div className='hei100' id='map' />

          <>{/* 头部状态栏  */}
            {
              JSON.stringify(airportData) !== '{}' &&
              <div
                className='pos_abs h40 wid100 pdRL16'
                style={{ top: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,0.6),rgba(0,0,0,0))' }}
              >
                <div className='flex jcsb align_center hei100'>
                  {/* left */}
                  <div className='flex jcc align_center'>
                    {/* 返航高度 */}
                    <span className='flex jcc align_center marR12'>
                      <Tooltip title='无人机返航高度'>
                        <img draggable='false' alt='返航高度' src={fhgd} />
                      </Tooltip>
                      <span style={{ color: colorText }}>{Number(UAVData?.rth_altitude || 0).toFixed(1)}m</span>
                    </span>

                    {/* 雨天 */}
                    <span>
                      <img
                        alt='天气'
                        draggable='false'
                        src={airportData?.rainfall === 1 ? xy : airportData?.rainfall === 2 ? zy : dy}
                        style={{ display: airportData?.rainfall > 0 && airportData?.rainfall < 65535 ? `` : `none` }}
                      />
                    </span>

                    {/* 风速 */}
                    <span className='flex jcc align_center marR12'>
                      <Tooltip title='风速'>
                        <img draggable='false' alt='风速' src={fs} />
                      </Tooltip>
                      <span style={{ color: colorText }}>{airportData?.wind_speed}m/s</span>
                    </span>

                    {/* 温度 */}
                    <span className='flex jcc align_center marR12'>
                      <Tooltip title='温度'>
                        <img draggable='false' alt='温度' src={wd} />
                      </Tooltip>
                      <span style={{ color: colorText }}>{airportData?.environment_temperature}℃</span>
                    </span>

                    {/* 湿度 */}
                    <span className='flex jcc align_center marR12'>
                      <Tooltip title='湿度'>
                        <img draggable='false' alt='湿度' src={sd} />
                      </Tooltip>
                      <span style={{ color: colorText }}>{airportData?.humidity}</span>
                    </span>
                  </div>

                  {/* 问题提示框 */}
                  {
                    JSON.stringify(warningMessage.mainMsg) !== '{}' &&
                    <div className='w280'>
                      <Alert
                        type={warningMessage.mainMsg?.level === 0 ? `success` : warningMessage.mainMsg?.level === 1 ? `warning` : warningMessage.mainMsg?.level === 2 ? `error` : ``}
                        showIcon
                        icon={warningMessage.mainMsg?.level === 0 ? <InfoCircleFilled /> : warningMessage.mainMsg?.level === 1 ? <ExclamationCircleFilled /> : warningMessage.mainMsg?.level === 2 ? <CloseCircleFilled /> : ``}
                        message={
                          <Marquee pauseOnHover gradient={false}>
                            <div
                              className='pointer'
                              onClick={async () => {
                                let war = warningMessage
                                war.mainMsg = {}
                                war.isOpen = true
                                war.isRead = true
                                setWarningMessage({ ...war })
                              }}
                            >
                              {warningMessage.mainMsg?.message_zh}
                            </div>
                          </Marquee>
                        }
                      ></Alert>
                    </div>
                  }

                  {/* right */}
                  <div className='flex jcc align_center'>
                    {/* 无人机是否链接 */}
                    <>
                      <Tooltip title={airportData?.mode_code !== 14 ? '无人机已连接' : '无人机未连接'}>
                        <img
                          className="marL12"
                          draggable='false'
                          alt='无人机'
                          src={airportData?.mode_code !== 14 ? t_wrj : f_wrj}
                        />
                      </Tooltip>
                    </>

                    {/* 当前网络 WiFi */}
                    <>
                      {/* <img draggable='false'
                            className="marL12"
                            alt='WiFi'
                            src={
                              headStatusBar.wifi === 1
                                ? wifi90
                                : headStatusBar.wifi === 2
                                  ? wifi60
                                  : headStatusBar.wifi === 3
                                    ? wifi30
                                    : headStatusBar.wifi === 4
                                      ? wifi0
                                      : headStatusBar.wifi === 5
                                        ? wifi_close
                                        : wifi_none
                            }
                          /> */}
                    </>

                    {/* SDR信号 */}
                    <>
                      <Tooltip title={`SDR信号:${airportData?.wireless_link_sdr_quality}`}>
                        <img
                          className="marL12"
                          // style={{ display: airportData?.wireless_link_sdr_link_state ? `` : `none` }}
                          draggable='false'
                          alt='SDR'
                          src={
                            airportData?.wireless_link_sdr_quality < 2
                              ? sdr0
                              : airportData?.wireless_link_sdr_quality < 4
                                ? sdr15
                                : airportData?.wireless_link_sdr_quality < 6
                                  ? sdr35
                                  : airportData?.wireless_link_sdr_quality < 8
                                    ? sdr55
                                    : airportData?.wireless_link_sdr_quality < 9
                                      ? sdr75
                                      : sdr95
                          }
                        />
                      </Tooltip>
                    </>

                    {/* 网络 1:4G| 2:以太网 */}
                    <>
                      {
                        airportData?.network_state_type === 1//4G
                          ? (
                            <>
                              <Tooltip title={`${airportData?.network_state_rate}KB/s`}>
                                <img
                                  className="marL12"
                                  style={{ display: airportData?.wireless_link_4g_link_state ? `` : `none` }}
                                  draggable='false'
                                  alt='4g'
                                  src={
                                    airportData?.wireless_link_4g_gnd_quality < 2
                                      ? cell0
                                      : airportData?.wireless_link_4g_gnd_quality < 4
                                        ? cell15
                                        : airportData?.wireless_link_4g_gnd_quality < 6
                                          ? cell35
                                          : airportData?.wireless_link_4g_gnd_quality < 8
                                            ? cell55
                                            : airportData?.wireless_link_4g_gnd_quality < 9
                                              ? cell75
                                              : cell95
                                  }
                                />
                              </Tooltip>
                            </>
                          )
                          : airportData?.network_state_type === 2//以太网
                            ? (
                              <>
                                <Tooltip title={`${airportData?.network_state_rate}KB/s`}>
                                  <img
                                    style={{ display: airportData?.network_state_type === 2 ? `` : `none` }}
                                    className="marL12"
                                    draggable='false'
                                    alt='以太网'
                                    src={Ethernet}
                                  />
                                </Tooltip>
                              </>
                            )
                            : <></>
                      }
                    </>

                    {/* 当前电量 */}
                    <>
                      <div className='marL12'>
                        <Tooltip title={airportData?.drone_charge_state_state ? `充电中(${airportData?.drone_charge_state_capacity_percent}%)···` : `${airportData?.drone_charge_state_capacity_percent}%`}>
                          <img
                            className=""
                            draggable='false'
                            alt='电量'
                            src={
                              airportData?.drone_charge_state_state
                                ? dl_charge
                                : airportData?.drone_charge_state_capacity_percent < 11
                                  ? dl0
                                  : airportData?.drone_charge_state_capacity_percent < 26
                                    ? dl25
                                    : airportData?.drone_charge_state_capacity_percent < 51
                                      ? dl50
                                      : airportData?.drone_charge_state_capacity_percent < 76
                                        ? dl75
                                        : airportData?.drone_charge_state_capacity_percent < 101
                                          ? dl100
                                          : dl_charge
                            }
                          />
                        </Tooltip>
                      </div>
                    </>

                    {/* 机场信息 */}
                    <>
                      <img
                        className='pointer marL12'
                        draggable='false'
                        alt='机场'
                        src={t_jc}
                        onClick={() => {
                          let glo = globalStatus
                          glo.isOpenSeeAirportInfo = !globalStatus.isOpenSeeAirportInfo
                          setGlobalStatus({ ...glo })
                        }}
                      />
                    </>

                    {/* 机场详细信息 */}
                    <>
                      {
                        globalStatus.isOpenSeeAirportInfo && JSON.stringify(airportData) !== '{}' &&
                        <div className='pos_abs pdR16 flex_col' style={{ top: 40, right: 0, zIndex: 1 }}>
                          <div
                            className='pos_abs w224 radius8 pd8 pos_rel'
                            style={{
                              top: '0', right: '0',
                              backgroundColor: 'rgba(0,0,0,0.7)',
                            }}>
                            <div>{airportData?.sn || `机场信息`} </div>
                            <Row>
                              {/* rtk数量 */}
                              <Col span={12} className='flex align_center'>
                                <span className="marR8">
                                  <Tooltip title='rtk数量'>
                                    <img draggable='false' src={rtk} alt='rtk数量' />
                                  </Tooltip>
                                </span>
                                <span>
                                  {airportData?.position_state_rtk_number}
                                </span>
                              </Col>

                              {/* gps数量 */}
                              <Col span={12} className='flex align_center'>
                                <span className="marR8">
                                  <Tooltip title='gps数量'>
                                    <img draggable='false' src={gps} alt='gps数量' />
                                  </Tooltip>
                                </span>
                                <span>
                                  {airportData?.position_state_gps_number}
                                </span>
                              </Col>


                              {/* 温度 */}
                              <Col span={12} className='flex align_center'>
                                <span className="marR8">
                                  <Tooltip title='温度'>
                                    <img className='h20 w20' draggable='false' src={wd} alt='温度' />
                                  </Tooltip>
                                </span>
                                <span>{airportData?.temperature}℃</span>
                              </Col>

                              {/* 湿度 */}
                              <Col span={12} className='flex align_center'>
                                <span className="marR8 ">
                                  <Tooltip title='湿度'>
                                    <img className='h20 w20' draggable='false' src={sd} alt='湿度' />
                                  </Tooltip>
                                </span>
                                <span>{airportData?.humidity}</span>
                              </Col>


                              <Col span={12} className='flex align_center'>
                                <span className="marR8">
                                  <Tooltip title='东经'>
                                    <img draggable='false' src={dj} alt='东经' />
                                  </Tooltip>
                                </span>
                                <span>{Number(airportData?.latitude || 0).toFixed(6)}</span>
                              </Col>

                              <Col span={12} className='flex align_center'>
                                <span className="marR8">
                                  <Tooltip title='北纬'>
                                    <img draggable='false' src={bw} alt='北纬' />
                                  </Tooltip>
                                </span>
                                <span>{Number(airportData?.longitude || 0).toFixed(6)}</span>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      }
                    </>
                  </div>
                </div>
              </div>
            }
          </>

          <>{/* 左上角 切换地图图层 */}
            {
              false &&
              <>
                <div className="pos_abs radius8 pointer" style={{ top: '48px', left: '24px', background: '#0E0E0E' }}
                >
                  {/* <BlockOutlined className="w16 h16 mar12" style={{ color: 'white' }} /> */}
                  <Button icon={<BlockOutlined />} onClick={() => { setOpacity(!opacity) }} />
                </div>
              </>
            }
          </>

          <>{/* 左侧 详细警告信息 */}
            <div className="pos_abs radius8 w300"
              style={{
                top: '48px', left: '16px',
                background: 'rgba(0,0,0,0.7)',
                display: warningMessage.isOpen ? `` : `none`,
                zIndex: 1,
              }}
            >
              <div className='flex jcr mar4'>
                <CloseOutlined
                  className='opa45 pointer'
                  onClick={async () => {
                    let war = warningMessage
                    war.isOpen = false
                    war.isRead = false
                    setWarningMessage({ ...war })
                    let res = await airportHealthInfoReadAPI({
                      access_token: token,
                      ids: warningMessage.ids.join(',')
                    })
                    if (res.ret !== 200) { message.warning(res.msg || '只读失败') }
                    getAirporintInfo()
                  }}
                />
              </div>
              <div className='marTB12 marRL16 hidden'
                style={{ maxHeight: 'calc(100vh - 616px)', overflowY: 'auto' }}
              >
                {/* 无人机 */}
                <div
                  style={{ borderBottom: '1px solid ' + colorBorderSecondary, display: warningMessage.UAVMsg.length > 0 ? `` : `none` }}
                >
                  <Tag className='marB8'>无人机</Tag>
                  <div className='marB8'>
                    {
                      (warningMessage.UAVMsg || []).map((res, index) => {
                        return (
                          <div className='flex jcsb' key={index}>
                            <div
                              className='marR8'
                              style={{
                                wordBreak: 'break-all',
                                color:
                                  res.level === 0
                                    ? `rgb(82,196,26)`
                                    : res.level === 1
                                      ? `#D89614`
                                      : res.level === 2
                                        ? `#DC4446`
                                        : ``,
                              }}
                            >
                              {res.message_zh}
                            </div>

                            <div className='w55 opa45'>{res.time}</div>
                          </div>
                        )
                      })
                    }

                  </div>
                </div>

                {/* 机场 */}
                <div
                  className='marTB8'
                  style={{ display: warningMessage.airportMsg.length > 0 ? `` : `none` }}
                >
                  <Tag className='marB8'>机场</Tag>
                  <div className='marB8'>
                    {
                      (warningMessage.airportMsg || []).map((res, index) => {
                        return (
                          <div className='flex jcsb' key={index}>
                            <div
                              className='marR8'
                              style={{
                                wordBreak: 'break-all',
                                color:
                                  res.level === 0
                                    ? `rgb(82,196,26)`
                                    : res.level === 1
                                      ? `#D89614`
                                      : res.level === 2
                                        ? `#DC4446`
                                        : ``,
                              }}
                            >
                              {res.message_zh}
                            </div>

                            <div className='w55 opa45'>{res.time}</div>
                          </div>
                        )
                      })
                    }
                  </div>

                </div>
              </div>
            </div>
          </>

          <>{/* 右下  信息栏  */}
            {
              <div
                className='pos_abs flex_row radius8'
                style={{ bottom: '16px', right: '16px', pointerEvents: 'auto' }}
              >
                {/* 无人机详细信息 */}
                <>
                  <div className='marR16'>
                    {
                      (globalStatus.isOpenSeeUAVInfo && JSON.stringify(UAVData) !== '{}') &&
                      <div
                        className=' radius8 pd8 flex_col '
                        style={{
                          // top: '-210px', right: '332px',
                          backgroundColor: 'rgba(0,0,0,0.7)',
                        }}
                      >
                        {/* 无人机编号 */}
                        <div>{UAVData?.sn || `无人机信息`}</div>
                        <div className='flex_row flex_shrink0'>
                          <div className='flex_auto marR16 flex_shrink0'>
                            {/* rtk数量 */}
                            <div>
                              <span className="marR8">
                                <Tooltip title='rtk数量'>
                                  <img draggable='false' src={rtk} alt='rtk数量' />
                                </Tooltip>
                              </span>
                              <span>
                                {UAVData?.position_state_rtk_number || 0}
                              </span>
                            </div>
                            {/* 东经 */}
                            <div>
                              <span className="marR8">
                                <Tooltip title='东经'>
                                  <img draggable='false' src={dj} alt='东经' />
                                </Tooltip>
                              </span>
                              <span>{Number(UAVData?.latitude || 0).toFixed(6)}</span>
                            </div>
                            {/* 相对起飞点高度 */}
                            <div>
                              <span className="marR8">
                                <Tooltip title='相对起飞点高度'>
                                  <img draggable='false' src={xdqfgd} alt='相对起飞点高度' />
                                </Tooltip>
                              </span>
                              <span>{Number(UAVData?.elevation || 0).toFixed(2)} m</span>
                            </div>
                            {/* 水平速度 */}
                            <div>
                              <span className="marR8">
                                <Tooltip title='水平速度'>
                                  <img draggable='false' src={spsd} alt='水平速度' />
                                </Tooltip>
                              </span>
                              <span>{Number(UAVData?.horizontal_speed || 0).toFixed(1)}</span>
                            </div>
                          </div>

                          <div className='flex_auto marR16 flex_shrink0'>
                            {/* GPS数量 */}
                            <div>
                              <span className="marR8">
                                <Tooltip title='GPS数量'>
                                  <img draggable='false' src={gps} alt='GPS数量' />
                                </Tooltip>
                              </span>
                              <span>
                                {UAVData?.position_state_gps_number || 0}
                              </span>
                            </div>
                            {/* 北纬 */}
                            <div>
                              <span className="marR8">
                                <Tooltip title='北纬'>
                                  <img draggable='false' src={bw} alt='北纬' />
                                </Tooltip>
                              </span>
                              <span>{Number(UAVData?.longitude || 0).toFixed(6)}</span>
                            </div>
                            {/* 海拔 */}
                            <div>
                              <span className="marR8">
                                <Tooltip title='海拔'>
                                  <img draggable='false' src={hbgd} alt='海拔' />
                                </Tooltip>
                              </span>
                              <span>{Number(UAVData?.height || 0).toFixed(1)}</span>
                              {/* <span>N/A</span> */}
                            </div>
                            {/* 垂直速度 */}
                            <div>
                              <span className="marR8">
                                <Tooltip title='垂直速度'>
                                  <img draggable='false' src={czsd} alt='垂直速度' />
                                </Tooltip>
                              </span>
                              <span>{Number(UAVData?.vertical_speed || 0).toFixed(1)}</span>
                            </div>
                          </div>
                          {/* 无人机离机场距离 */}
                          <div className='flex_col flex_shrink0'>
                            <div className='flex_auto'></div>
                            <div>
                              <span className="marR8">
                                <Tooltip title='无人机离机场距离'>
                                  <img draggable='false' src={jcjl} alt='无人机离机场距离' />
                                </Tooltip>
                              </span>
                              <span>
                                {
                                  UAVData?.longitude && airportData?.longitude
                                    ? distance([UAVData?.longitude, UAVData?.latitude], [airportData?.longitude, airportData?.latitude]).toFixed(1)
                                    : 0.0
                                } m
                              </span>
                            </div>
                          </div>
                        </div>

                        <div></div>

                      </div>
                    }
                  </div>
                </>

                {/* 指令飞行相关信息 */}
                <div className='flex_col jcr'>
                  {/* 无人机飞行时数据 */}
                  <>
                    {
                      JSON.stringify(UAVData) !== '{}' &&
                      <div
                        className='w300 pdT16 pdRL24 pdB24 radius8'
                        style={{ backgroundColor: '#0E0E0E' }}
                      >
                        <div>
                          {/* 第一层 */}
                          <div className='flex jcsb align_center marB8'>
                            {/* 无人机详细信息 */}
                            <div>
                              <InfoCircleOutlined
                                className='fs16'
                                onClick={() => {
                                  let glo = globalStatus
                                  glo.isOpenSeeUAVInfo = !glo.isOpenSeeUAVInfo
                                  setGlobalStatus({ ...glo })
                                }}
                              />
                            </div>

                            <Space>
                              <>{/* 避障 */}
                                <Tooltip title='上视规避'>{/* 上视规避 */}
                                  <img className='w24 h24' draggable='false' src={UAVData?.obstacle_avoidance_upside ? uav_t_ssbz : uav_f_ssbz} alt='上视规避'
                                  />
                                </Tooltip>
                                <Tooltip title='水平规避'>{/* 水平规避 */}
                                  <img className='w24 h24' draggable='false' src={UAVData?.obstacle_avoidance_horizon ? uav_t_spbz : uav_f_spbz} alt='水平规避' />
                                </Tooltip>

                                <Tooltip title='下视规避'>{/* 下视规避 */}
                                  <img
                                    alt='下视规避'
                                    draggable='false'
                                    className='w24 h24'
                                    src={UAVData?.obstacle_avoidance_downside ? uav_t_xsbz : uav_f_xsbz}
                                  />
                                </Tooltip>
                              </>

                              <>{/* RTK 收敛状态 */}
                                <Tooltip
                                  title={
                                    Number(UAVData?.position_state_is_fixed) === 0
                                      ? '未开始'
                                      : Number(UAVData?.position_state_is_fixed) === 1
                                        ? '收敛中'
                                        : Number(UAVData?.position_state_is_fixed) === 2
                                          ? '收敛成功'
                                          : '收敛失败'
                                  }
                                >
                                  {
                                    Number(UAVData?.position_state_is_fixed) === 0
                                      ? (<img className='w24 h24' draggable='false' src={convergence0} alt='收敛 未开始' />)
                                      : Number(UAVData?.position_state_is_fixed) === 1
                                        ? (<img className='w24 h24' draggable='false' src={convergence1} alt='收敛 收敛中' />)
                                        : Number(UAVData?.position_state_is_fixed) === 2
                                          ? (<img className='w24 h24' draggable='false' src={convergence2} alt='收敛 收敛成功' />)
                                          : Number(UAVData?.position_state_is_fixed) === 3
                                            ? (<img className='w24 h24' draggable='false' src={convergence3} alt='收敛 收敛失败' />)
                                            : (<img className='w24 h24' draggable='false' src={convergence3} alt='收敛 收敛失败' />)
                                  }
                                </Tooltip>

                              </>
                            </Space>
                          </div>

                          {/* 第二层 飞行速度 */}
                          <div className='fs99 lh80 flex align_center jcc'>
                            <b>
                              {
                                UAVData?.horizontal_speed
                                  ? Number(UAVData?.horizontal_speed || 0).toFixed(1)
                                  : Number(UAVData?.vertical_speed || 0).toFixed(1)
                              }
                            </b>
                          </div>

                          {/* 第三层 */}
                          <div className='flex_row jcsb marT8'>
                            {/* 飞行状态 */}
                            <div className='w68 flex jcsb'>
                              {/* P */}
                              <img
                                className='pointer'
                                alt='P'
                                src={droneStatus.current === 1 ? uav_t_p : uav_f_p}
                                onClick={() => {
                                  // droneStatus.current = 1
                                }}
                              />
                              {/* A */}
                              <img
                                className='pointer'
                                alt='A'
                                src={droneStatus.current === 2 ? uav_t_a : uav_f_a}
                                onClick={() => {
                                  // droneStatus.current = 2
                                }}
                              />
                              {/* M */}
                              <img
                                className='pointer'
                                alt='M'
                                src={droneStatus.current === 3 ? uav_t_m : uav_f_m}
                                onClick={() => {
                                  droneStatus.current = 3
                                }}
                              />
                            </div>
                            {/* 速度txt */}
                            <div>m/s</div>
                            <div>
                              {/* 电量 */}
                              <div className='w67 flex jcr align_center'>
                                <span
                                  className='fs20 lh25'
                                  style={{
                                    color: UAVData?.battery_capacity_percent > 30 ? '#25CB55' : '#E50019', opacity: '0.75'
                                  }}
                                >
                                  <b>{`${UAVData?.battery_capacity_percent || 0}%`}</b>
                                </span>
                                <img draggable='false' src={UAVData?.battery_capacity_percent > 30 ? uav_t_dl : uav_f_dl} alt='uav_dl' />
                              </div>
                            </div>
                          </div>

                          {/* 第四层 */}
                          <div className='flex jcsb h25 marT8'>
                            {/* 相对起飞高度 */}
                            <div className='flex jcc align_center'>
                              <Tooltip title='无人机绝对高度'><img draggable='false' className='marR4 w32 h25' src={uav_xdqfdgd} alt='uav_xdqfdgd' /></Tooltip>
                              <div className=' fs20 lh25 flex align_center'>
                                {/* 无人机绝对高度 */}

                                <b>{`${Number(UAVData?.height || 0).toFixed(0)}`}</b>

                                {/* 相对起飞点高度 */}
                                <Tooltip title='相对起飞点高度'><Tag className='marL8'>{`${Number(UAVData?.elevation || 0).toFixed(0)} m`}</Tag></Tooltip>
                              </div>
                            </div>
                            {/* 相对机场距离 */}
                            <div className='flex jcc align_center'>
                              <Tooltip title='相对机场距离'>
                                <img draggable='false' className='marR4 lh25' src={uav_xdjcgd} alt='uav_xdjcgd' />
                              </Tooltip>
                              <span className='fs20 lh25'>
                                <b>
                                  {
                                    UAVData?.longitude && airportData?.longitude
                                      ? distance([UAVData?.longitude, UAVData?.latitude], [airportData?.longitude, airportData?.latitude]).toFixed(0)
                                      : 0
                                  } m
                                </b>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    }


                  </>

                  {/* 无人机飞行状态 */}
                  <>
                    {
                      status[UAVData?.mode_code] && false &&
                      <div
                        className='marT16 radius8 pdTB16 pdRL24'
                        style={{ backgroundColor: '#0E0E0E' }}
                      >
                        <div className='fs20 fw400 lh25'>
                          {status[UAVData?.mode_code]}
                        </div>
                      </div>
                    }
                  </>

                  {/* 坐标点的经纬度信息 */}
                  <>
                    {
                      anchorPoint.length > 0 && implementType.current !== 0 &&
                      <Card className='w300 marT16'>
                        <Form
                          className='wid100'
                          form={anchorPointForm}
                          name='form'
                          onFinish={onFinish}
                        >
                          <Form.Item
                            style={{ margin: '0 0 8px 0' }}
                            label="经度"
                            name="lng" rules={[{ required: true, message: '请输入经度', }]}>
                            <InputNumber
                              disabled={
                                implementType.current === 1
                                  ? true
                                  : isEditMap.current
                                    ? false
                                    : true
                              }
                              className='wid100'
                              placeholder="-"
                              step={0.001}
                              onChange={async (e) => {
                                let coo = coordinatePointInfo
                                coo.lng = e
                                setCoordinatePointInfo({ ...coo })
                                setAnchorPoint([e ? e : 0, anchorPoint[1]])
                                coo.surfaceElevation = [1, 2].indexOf(implementType.current) > -1 ? coo.takeoffElevation : await GetAltitudeFun([e, coo.lat])
                                coo.reachingAltitude = Number(coo.surfaceElevation) + Number(coo.takeoffAltitude)
                                // 创建定位点后将默认值写入表单
                                anchorPointForm.setFieldsValue({
                                  surfaceElevation: coo.surfaceElevation,//地表海拔
                                  reachingAltitude: coo.reachingAltitude,//到达高度
                                })
                                setCoordinatePointInfo({ ...coo })
                                if (distance([UAVData.longitude, UAVData.latitude], [coo.lng, coo.lat]) > 0.5) { isClickBtn.current = true } else { isClickBtn.current = false }
                              }}
                            />
                          </Form.Item>

                          <Form.Item
                            style={{ margin: '0 0 8px 0' }}
                            label="纬度"
                            name="lat"
                            rules={[{ required: true, message: '请输入纬度', }]}>
                            <InputNumber
                              disabled={
                                implementType.current === 1
                                  ? true
                                  : isEditMap.current
                                    ? false
                                    : true
                              }
                              className='wid100'
                              placeholder="-"
                              step={0.001}
                              onChange={async (e) => {
                                let coo = coordinatePointInfo
                                coo.lat = e
                                setCoordinatePointInfo({ ...coo })
                                setAnchorPoint([anchorPoint[0], e ? e : 0])
                                coo.surfaceElevation = [1, 2].indexOf(implementType.current) > -1 ? coo.takeoffElevation : await GetAltitudeFun([coo.lng, e])
                                coo.reachingAltitude = Number(coo.surfaceElevation) + Number(coo.takeoffAltitude)
                                // 创建定位点后将默认值写入表单
                                anchorPointForm.setFieldsValue({
                                  surfaceElevation: coo.surfaceElevation,//地表海拔
                                  reachingAltitude: coo.reachingAltitude,//到达高度
                                })
                                setCoordinatePointInfo({ ...coo })
                                if (distance([UAVData.longitude, UAVData.latitude], [coo.lng, coo.lat]) > 0.5) { isClickBtn.current = true } else { isClickBtn.current = false }
                              }}
                            />
                          </Form.Item>

                          <Form.Item
                            style={{ margin: '0 0 8px 0', }}
                            label="巡航速度"
                            name="cruiseSpeed"
                            rules={[{ required: true, message: '请输入速度', }]}
                          >
                            <InputNumber
                              disabled={!isEditMap.current}
                              addonAfter="m/s"
                              placeholder='-'
                              onChange={(e) => {
                                let coo = coordinatePointInfo
                                coo.cruiseSpeed = e
                                setCoordinatePointInfo({ ...coo })
                              }}
                            />
                          </Form.Item>

                          <Form.Item
                            style={{ margin: '0 0 8px 0' }}
                            label={`${[1, 2].indexOf(implementType.current) > -1 ? '起飞高度' : '飞行高度'}`}
                            name="takeoffAltitude"
                            rules={[{ required: true, message: '请输入起飞高度', }]}
                          >
                            <InputNumber
                              disabled={!isEditMap.current}
                              addonAfter="m"
                              placeholder='-'
                              onChange={(e) => {
                                let coo = coordinatePointInfo
                                coo.takeoffAltitude = e
                                coo.reachingAltitude = Number(e) + Number(coo.surfaceElevation)
                                anchorPointForm.setFieldsValue({
                                  takeoffAltitude: coo.takeoffAltitude,//地表海拔
                                  reachingAltitude: coo.reachingAltitude,
                                })
                                setCoordinatePointInfo({ ...coo })
                                if (coo.lastFlightAltitude !== e) { isClickBtn.current = true } else { isClickBtn.current = false }//修改后的高度与修改前的高度对比
                              }}
                            />
                          </Form.Item>

                          <Form.Item
                            style={{ margin: '0 0 8px 0' }}
                            label={`${[1, 2].indexOf(implementType.current) > -1 ? '机场海拔' : '地表海拔'}`}
                            name="surfaceElevation"
                            rules={[{ required: true, message: '请输入地表海拔', }]}
                          >
                            <div className='flex'>
                              <InputNumber
                                value={[1, 2].indexOf(implementType.current) > -1 ? coordinatePointInfo.takeoffElevation : coordinatePointInfo.surfaceElevation}
                                disabled={[1, 2].indexOf(implementType.current) > -1 || !isEditMap.current}
                                addonAfter="m"
                                placeholder='-'
                                onChange={(e) => {
                                  let coo = coordinatePointInfo
                                  coo.surfaceElevation = e
                                  coo.reachingAltitude = Number(e) + Number(coo.takeoffAltitude)
                                  anchorPointForm.setFieldsValue({
                                    surfaceElevation: coo.surfaceElevation,//地表海拔
                                    reachingAltitude: coo.reachingAltitude,
                                  })
                                  setCoordinatePointInfo({ ...coo })
                                }}
                              />
                              <div>
                                {/* 刷新地表海拔 */}
                                <Button disabled={[1, 2].indexOf(implementType.current) > -1 || !isEditMap.current}
                                  className='marL8 wid100'
                                  icon={<SyncOutlined />}
                                  onClick={async () => {
                                    let coo = coordinatePointInfo
                                    coo.surfaceElevation = await GetAltitudeFun(anchorPoint)
                                    coo.reachingAltitude = Number(coo.surfaceElevation) + Number(coo.takeoffAltitude)
                                    anchorPointForm.setFieldsValue({
                                      surfaceElevation: coo.surfaceElevation,//地表海拔
                                      reachingAltitude: coo.reachingAltitude,
                                    })
                                    setCoordinatePointInfo({ ...coo })

                                  }}
                                />
                              </div>
                            </div>
                          </Form.Item>

                          <Form.Item
                            style={{ margin: '0 0 8px 0' }}
                            label={`${[1, 2].indexOf(implementType.current) > -1 ? '到达高度' : '飞行海拔'}`}
                            name="reachingAltitude"
                            rules={[{ required: true, message: '请输入到达高度', }]}
                          >
                            <InputNumber
                              disabled
                              addonAfter="m"
                              placeholder='-'
                              value={Number(coordinatePointInfo.reachingAltitude)}
                            />
                          </Form.Item>

                          {/* 执行takeoff */}
                          {
                            <>
                              <Divider className='marB24' />
                              {/* 按钮集合 */}
                              <Form.Item style={{ margin: '0 0 8px 0' }}>
                                <div>
                                  <div className='marB8'>
                                    {/* 执行 执行takeoff 和 loading */}
                                    {
                                      <Button
                                        disabled={!isClickBtn.current || isCompute.current}
                                        icon={
                                          takeoffLoading || implementType.current === 2 || implementType.current === 5 || implementType.current === 7
                                            ?
                                            <LoadingOutlined />
                                            :
                                            <CaretRightOutlined />
                                        }
                                        type='primary'
                                        className='wid100'
                                        onClick={() => {
                                          if (isCompute.current) {
                                            message.warning('正在计算海拔，请稍后')
                                            return
                                          }
                                          if (implementType.current === 1) {//takeoff
                                            getDockElectricity();
                                            let coo = coordinatePointInfo
                                            coo.lastFlightAltitude = coo.takeoffAltitude
                                            setCoordinatePointInfo({ ...coo })
                                          }
                                          if (implementType.current === 4) {//flyto
                                            isEditMap.current = false
                                            let anc = anchorPointList
                                            anc.push(anchorPoint)
                                            setAnchorPointList([...anc])
                                            document.getElementById("anchorPointForm").click()
                                            let coo = coordinatePointInfo
                                            coo.lastFlightAltitude = coo.takeoffAltitude
                                            setCoordinatePointInfo({ ...coo })
                                          }
                                        }}
                                      >
                                        {implementType.current === 1
                                          ? `起飞`
                                          : implementType.current === 2
                                            ? `起飞中`
                                            : implementType.current === 5
                                              ? `前往航点中`
                                              : implementType.current === 7
                                                ? `返航中`
                                                : `前往航点`
                                        }
                                      </Button>
                                    }
                                  </div>

                                  <div className='flex marT8'>
                                    <Button
                                      className='wid100 marR8'
                                      icon={<StopOutlined />}
                                      disabled={implementType.current !== 5}
                                      onClick={async () => {
                                        let res = await stopFlytoAPI({
                                          access_token: token,
                                          dock_id: dockIdRef.current,
                                        })
                                        if (res.ret !== 200) { message.warning(res.msg || '停止失败') }
                                        message.success(res.msg || '停止成功')
                                      }}
                                    >
                                      停止
                                    </Button>

                                    <Button
                                      className='wid100'
                                      icon={<DownloadOutlined />}
                                      disabled={[1, 2, 6].indexOf(implementType.current) > -1 || UAVData.mode_code === 10}
                                      onClick={async () => {
                                        if (implementType.current === 7) {
                                          let res = await cancelReturnFlightAPI({
                                            access_token: token,
                                            dock_id: dockIdRef.current
                                          })
                                          if (res.ret !== 200) { message.warning(res.msg || '取消返航失败') }
                                          message.success(res.msg || '取消返航成功')
                                        } else {
                                          isClickBtn.current = true
                                          returnBack()
                                        }
                                      }}
                                    >
                                      {
                                        `${implementType.current === 7 ? '停止返航' : '返航'}`
                                      }
                                    </Button>
                                  </div>
                                </div>
                              </Form.Item>
                            </>
                          }

                          <Button
                            id='anchorPointForm'
                            type="primary"
                            htmlType="submit"
                            style={{ display: 'none' }}
                          >
                            执行
                          </Button>
                        </Form>
                      </Card>
                    }
                  </>

                  {/* 指令飞行  省略隐藏操作直接进行点击 */}
                  <>
                    <div
                      className='radius8 flex jcr marT16'
                      style={{ display: implementType.current === 0 && airportData?.latitude ? `none` : `none` }}
                    >
                      <Button
                        id='addFixedPoint'
                        icon={<PlusOutlined />}
                        onClick={() => {
                          let coo = { ...coordinatePointInfo }
                          let point = [Number(airportData?.longitude || 0), Number(airportData?.latitude || 0)]
                          implementType.current = 1
                          setImplementTypeState(1)
                          isClickBtn.current = true
                          localStorage.setItem('dock_anchorPoint', [point[0], point[1]]);
                          coo.lng = point[0]
                          coo.lat = point[1]
                          coo.surfaceElevation = coo.takeoffElevation
                          coo.reachingAltitude = Number(coo.surfaceElevation) + Number(coo.takeoffAltitude)
                          // 创建定位点后将默认值写入表单
                          anchorPointForm.setFieldsValue({
                            lng: point[0],//经度
                            lat: point[1],//纬度
                            cruiseSpeed: coo.cruiseSpeed,//巡航速度
                            takeoffAltitude: coo.takeoffAltitude,//起飞高度
                            surfaceElevation: coo.surfaceElevation,//地表海拔
                            reachingAltitude: coo.reachingAltitude,//到达高度
                          })
                          setAnchorPoint([...point])
                          setCoordinatePointInfo({ ...coo })
                        }}
                      >
                        定点
                      </Button>
                    </div>
                  </>
                </div>
              </div>
            }
          </>
        </div>

        <>{/* 新版本  视频栏 */}
          {
            <div
              className='pos_abs radius8 mar16 marB24'
              style={{ bottom: '24px', left: '24px', display: UAVLiveStreamStart ? `` : `none` }}
            >
              <>
                <>{/* 变焦加减 */}
                  <div className='hei100 marB8 flex jcr' style={{ display: lensType === 'zoom' ? `` : `none` }}>
                    <div
                      className='flex align_center pdTB9 pdRL7 radius8'
                      style={{ backgroundColor: '#000' }}
                    >
                      <PlusOutlined
                        className='marRL8'
                        onClick={async () => {
                          if (zoomValue >= 1 && zoomValue < 10) {
                            let zoo = zoomValue
                            zoo = (Number(zoo) + 1)
                            let obj = {
                              access_token: token,
                              dock_id: dockIdRef.current,
                              type: lensType,
                              zoom: zoo,
                            }
                            let res = await modifyZoomValueAPI(obj)
                            if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
                            message.success(res.msg || '增加变焦倍率成功')
                            setZoomValue(zoo)
                          }
                        }}
                      />
                      <Divider type="vertical" />

                      <MinusOutlined
                        className='marRL8'
                        onClick={async () => {
                          if (zoomValue > 2) {
                            let zoo = zoomValue
                            zoo = (Number(zoo) - 1)
                            let obj = {
                              access_token: token,
                              dock_id: dockIdRef.current,
                              type: lensType,
                              zoom: zoo,
                            }
                            let res = await modifyZoomValueAPI(obj)
                            if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
                            message.success(res.msg || '减小变焦倍率成功')
                            setZoomValue(zoo)
                          }
                        }}
                      />
                    </div>
                  </div>
                </>

                {/* 视频 操作 */}
                <div
                  className='flex jcsb  align_center wid100 radius8'
                  style={{ backgroundColor: '#000' }}
                >
                  {/* 拍照摄像 */}
                  <div className='flex jcc align_center marL8'>
                    {/* 摄像 */}
                    <img
                      className='pointer w14 h14'
                      src={camera ? is_f_Camera : is_t_Camera}
                      alt='是否开始摄像'
                      onClick={async () => {
                        let cam = camera
                        if (cam) {//结束录像
                          let obj = {
                            access_token: token,
                            dock_id: dockIdRef.current,
                          }
                          let res = await endVideoAPI(obj)
                          if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
                          message.success(res.msg || '结束录像')
                          cam = false
                          setCameraDate(null)
                        } else {//开始录像
                          let obj = {
                            access_token: token,
                            dock_id: dockIdRef.current,
                          }
                          let res = await startVideoAPI(obj)
                          if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
                          message.success(res.msg || '开始录像')
                          cam = true
                        }
                        setCamera(cam)
                      }}
                    />

                    {/* 分割线 */}
                    <Divider type="vertical" />

                    {/* 拍照 */}
                    <CameraOutlined
                      className='pointer'
                      onClick={async () => {
                        let obj = {
                          access_token: token,
                          dock_id: dockIdRef.current,
                        }
                        let res = await takePhotoAPI(obj)
                        if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
                        message.success(res.msg || '拍照成功')
                      }}
                    />

                    {/* 分割线 */}
                    <Divider type="vertical" />

                    {/* 刷新 */}
                    <SyncOutlined
                      className='pointer'
                      onClick={async () => {
                        liveAddress()
                      }}
                    />

                  </div>
                  {/* 摄像头类型 */}
                  <div>
                    <Segmented
                      value={lensType}
                      options={[
                        { value: 'wide', label: '广角', idx: 1, },
                        { value: 'zoom', label: '变焦', idx: 2, },
                        { value: 'ir', label: '红外', idx: 3, },
                      ]}
                      onChange={async (value) => {
                        let obj = {
                          access_token: token,
                          dock_id: dockIdRef.current,
                          type: value
                        }
                        let res = await changeLensAPI(obj)
                        if (res.ret !== 200) { message.warning(res.msg || '切换镜头失败'); return }
                        message.success(res.msg)
                        setLensType(value)
                      }}
                    />
                  </div>
                </div>
              </>

              {/* 视频播放器 容器 */}
              <div
                className=' marT8 radius8 hidden '
                style={{ width: `${videoWidth}px`, height: `${videoHeight}px`, }}
              >

                <div className=' marT8 radius8 hidden flex jcc align_center'
                  style={{ backgroundColor: '#1D1D1D', width: `${videoWidth}px`, height: `${videoHeight}px`, }}
                >
                  <Spin spinning={loadingAll}>
                    {/* DOCK */}
                    {
                      !loadingAll &&
                      <div
                        className=' radius8'
                        style={{ display: !loadingAll ? `` : `none`, width: `${videoWidth}px`, height: `${videoHeight}px`, }}
                      >
                        <LiveVideo
                          type={999}
                          videoType={'cam'}
                          hasUAVData={UAVLiveStreamStart}
                          liveUrl={liveUrl.current}
                          liveVideoReturn={returnData}
                        />
                      </div>
                    }
                  </Spin>
                </div>


                <> {/* 屏幕上的信息显示 */}
                  <div
                    className='pos_abs flex_col jcsb radius8 pdTB8 pdRL12'
                    style={{ bottom: 0, left: 0, width: `${videoWidth}px`, height: `${videoHeight}px`, }}
                  >
                    {/* <div className='cross pos_abs  wid100 hei100 radius8' style={{ top: 0, left: 0, }} /> */}
                    {/* 拖动样式 */}


                    {/* 上层 */}
                    <div className='flex jcsb align_center h31'>
                      {/* 直播信息 */}
                      <div className='flex align_center' style={{ display: camera ? `` : `none` }}>
                        <div className='flex jcr text fs14 lh14 fw700 flex marR4'>
                          REC
                        </div>
                        <img className='camera h10 w10' src={is_t_Camera} alt='摄像' />
                      </div>
                      {/* 占位 */}
                      <div style={{ display: camera ? `none` : `` }} />

                      {/* 摄像头类型 */}
                      <div>
                        {/* 广角 */}
                        <div style={{ display: lensType === 'wide' ? `` : `none` }}>
                          <div className='flex jcr text fs14 lh14 fw700 flex'>
                            W
                          </div>
                        </div>
                        {/* 变焦 */}
                        <div style={{ display: lensType === 'zoom' ? `` : `none` }}>
                          <div className='flex jcr text fs14 lh14 fw700 flex'>
                            Z
                          </div>
                          <div className='flex jcr text fs14 lh17 fw700'>
                            {zoomValue}
                          </div>
                        </div>
                        {/* 红外 */}
                        <div style={{ display: lensType === 'ir' ? `` : `none` }}>
                          <div className='flex jcr text fs14 lh14 fw700 flex'>
                            IR
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 下层 */}
                    <div className='flex jcsb align_center'>

                      {/* 下 左 */}
                      <div className='flex jcr text fs14 lh17 fw700'>

                      </div>

                      {/* 下 右 */}
                      <div className='flex jcr text fs14 lh17 fw700'>
                        {camera ? cameraDate : ''}
                      </div>
                    </div>

                    {/* 俯仰角 */}
                    <div
                      className='angle pos_abs'
                      style={{ bottom: 0, right: '-85px', }}
                    >
                      <Segmented
                        id='segmentedFY'
                        className=''
                        value={pitchAngle}
                        options={[
                          {
                            label: '俯',
                            value: 'topView',
                          },
                          {
                            label: '仰',
                            value: 'lookingUp',
                          }
                        ]}
                        onChange={async (value) => {
                          let obj = {
                            access_token: token,
                            dock_id: dockIdRef.current,
                            reset_mode: value === 'lookingUp' ? '0' : '1'
                          }
                          let res = await panTiltControlAPI(obj)
                          if (res.ret !== 200) { message.warning(res.msg || '切换俯仰角失败'); return }
                          message.success(res.msg || `切换到${value === 'lookingUp' ? `仰视` : `俯视`}成功`)
                          setPitchAngle(value)
                        }
                        }
                      />
                    </div>

                    {/* 放大缩小 视频框 */}
                    <div
                      className='pos_abs w40'
                      style={{ top: 0, right: 0, cursor: 'ne-resize', height: `${videoHeight}px` }}
                      onMouseDown={(event) => {
                        downMouse.current = true
                        setDownMouseState(true)
                        mouseWidth.current = event.clientX
                      }}
                      onMouseUp={(event) => {
                        setDownMouseState(false)
                        downMouse.current = false
                      }}
                      onMouseLeave={() => {
                        setDownMouseState(false)
                        downMouse.current = false
                      }}
                    />
                  </div>
                </>

              </div>
            </div>
          }
        </>

        <>{/* 鼠标指向显示信息 */}
          <div id='div_info' className='pos_abs radius8'
            style={{
              zIndex: 20,
              left: divLeft - 230,
              top: divTop - 120,
              padding: '6px 8px',
              color: 'white',
              fontSize: '14px',
              background: '#000000bf',
              display: floating.visible ? '' : 'none',
            }}
          >
            {floating.title}
          </div>
        </>
      </>
    </>
  )
}
export default VideoPatrolMonitor;